import React from 'react';
import { InView } from 'react-intersection-observer';
import '../styles/herocustom.css';

const VdiHeroCustom = () => {
  return (
    <section className="vdihero1-section-custom" role="banner" aria-labelledby="vdihero-title">
      <div className="vdihero-custom-content-container">
        <InView triggerOnce={true} threshold={0.1}>
          {({ inView, ref }) => (
            <header ref={ref} className={`vdihero-custom-content ${inView ? 'animate' : ''}`}>
              <h1 id="vdihero-title">Careers</h1>
            </header>
          )}
        </InView>
      </div>
    </section>
  );
};

export default VdiHeroCustom;